// Stringable turns out to be `any` in current TypeScript
// but this definition should be robust to upgrades
type Stringable = ConstructorParameters<typeof String>[0];

/**
 * Use this function like this:
 *
 *   const handle = "TOYOTA-%weird/parts"
 *   const myUrl = url`/vehicles/${handle}`;
 *
 * In this example `handle` will be URL encoded
 */
const url = (constants: TemplateStringsArray, ...interpolations: Stringable[]) => {
  // This is a tag function, a powerful tool for
  // string interpolation.
  //
  // In the example above, the constants param will
  // equal ["/vehicles/", ""] and the interpolations
  // param will equal ["TOYOTA-%weird/parts"].
  //
  // This lets us make changes to the params before
  // building the string.
  //
  // Learn more here:
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#tagged_templates

  return constants
    .map((constant, index) => constant + encodeURIComponent(String(interpolations[index] || '')))
    .join('');
};

export default url;
